const env = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',
  SECOND_SECRET_KEY: process.env.REACT_APP_SECOND_SECRET_KEY || 'gestcard-second-key-change-in-production',
  API_TIMEOUT: 30000
};

export default env;


